<template>
  <div id="pageDashboard">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <!-- mini statistic start -->
        <v-flex lg3 sm6 xs12>
          <router-link  to="/empresas">
            <v-tooltip bottom>
              <mini-statistic
              icon="fa fa-building"
              v-bind:title=totalcompanies
              sub-title="Empresas"
              color="indigo"
              slot="activator"      
              >
            </mini-statistic>
            <span>Acessar</span>
          </v-tooltip>  
        </router-link>
      </v-flex>

      <v-flex lg3 sm6 xs12>
        <router-link  to="/treinamentos">
          <v-tooltip bottom>
            <mini-statistic
            icon="fa fa-volume-up"
            v-bind:title=trainings
            sub-title="Treinamentos"
            color="indigo"
            slot="activator"       
            >
          </mini-statistic>
          <span>Acessar</span>
        </v-tooltip>  
      </router-link>           
    </v-flex>      

    <v-flex lg3 sm6 xs12>
      <router-link  to="/turmas">
        <v-tooltip bottom>
          <mini-statistic
          icon="fa fa-users"
          v-bind:title="teams"
          sub-title="Turmas"
          color="indigo"
          slot="activator"       
          >
        </mini-statistic>
        <span>Acessar</span>
      </v-tooltip>  
    </router-link>           
  </v-flex>

  <v-flex lg3 sm6 xs12>
    <router-link  to="/usuarios">
      <v-tooltip bottom>
        <mini-statistic
        icon="fa fa-user-circle"
        v-bind:title="users"
        sub-title="Usuários"
        color="indigo"
        slot="activator"       
        >
      </mini-statistic>
      <span>Acessar</span>
    </v-tooltip>  
  </router-link>            
</v-flex>



<v-flex sm12>
  <div class="col-md-12" style="float: right;">
    <v-dialog v-model="modalday.dialog" persistent max-width="50%">
      <v-btn color="primary" dark slot="activator">Treinamentos que estão vencendo: De {{ dataPtBr(validityFrom)   }} até {{ dataPtBr(validityTo) }}</v-btn>
      <v-card>
        <v-card-title>
          <span class="headline">Escolha a data</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6>
                <v-text-field
                label="Data Inicial"
                type="date"
                v-model="validityFrom"
                required autofocus></v-text-field>
              </v-flex>                    
              <v-flex xs6>
                <v-text-field
                label="Data Final"
                type="date"
                v-model="validityTo"
                required autofocus></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="modalday.dialog = false">Fechar</v-btn>
          <v-btn color="blue darken-1" flat @click="updateFilter()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</v-flex>
<v-flex lg12>
  <vue-good-table
  :columns="columns"
  :rows="certificados"
  :pagination-options="{
  enabled: true,
  nextLabel: 'next',
  prevLabel: 'prev',
  rowsPerPageLabel: 'Registros por página',
  ofLabel: 'of',
  allLabel: 'Todos',
}"
styleClass="vgt-table bordered vgt-table condensed">
</vue-good-table>
</v-flex>


</v-layout>
</v-container>
</div>
</template>

<script>
import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
import {http, httpLogin} from '../../backend/vue-axios/axios';
import swal from 'sweetalert';
import moment from 'moment';
export default {
  components: {
    MiniStatistic,  
  },
  data () {
    return {
      totalcompanies: null,
      trainings: null,
      users: null,
      teams: null,
      certificados: [],
      validityFrom: moment().subtract(15, 'days').format('YYYY-MM-DD'),
      validityTo: moment().format('YYYY-MM-DD'),
      columns: [    
      {
        label: 'Descrição Treinamento',
        field: 'training.description',
      },      
      {
        label: 'Validade',
        field: 'validity',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DD',
        dateOutputFormat: 'DD/MM/YYYY',
      }
      ],
      modalday: {
        dialog: false
      },  
    };
  },
  computed: {

  },
  mounted()
  {
    this.buscaEmpresa()
    this.buscaTreinamentos()
    this.buscaUser()
    this.buscaTurmas()
    this.buscaCertificados()
  },
  methods:{


    dataPtBr : function (date) {
      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },

    buscaEmpresa() {

      http.get('companies')
      .then(response => {
       this.totalcompanies = response.data.length;

     })
      .catch(error => {
        console.log()
      });
    },

    buscaTreinamentos() {

      http.get('trainings')
      .then(response => {
       this.trainings = response.data.length;
     })
      .catch(error => {
      });
    },    

    buscaTurmas() {

      http.get('teams')
      .then(response => {
       this.teams = response.data.length;
     })
      .catch(error => {
      });
    },    

    buscaUser() {

      http.get('users')
      .then(response => {
        var users = [];
        for (var i = 0; i < response.data.length; i++) {

          if(response.data[i].role === 1) {
            users.push(response.data[i])
          }
        }
        this.users = users.length;
      })
      .catch(error => {

      });
    },

    updateFilter() {

      this.modalday.dialog = false;
      this.buscaCertificados()
      swal({
        title: "Verifique!",
        text: "as turmas que estão vencendo o certificado.",
        icon: "success",
        timer: 1000,
        button: false

      });
    },

    buscaCertificados() {
      http.get('teams?validityFrom='+ this.validityFrom +'&validityTo='+ this.validityTo +'')
      .then(response => {
        this.certificados = response.data;
      })
      .catch(error => {
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue